import axios from "axios";
import { getFromStorage, renderErrorMessage, renderSuccessMessage } from "../assets/functions";

export const signIn = (data) => {
    return api.post("/customers/login", data);
};

export const signUp = (data) => {
    return api.post("/customers/register", data);
};

export const resetEmail = (data) => {
    return api.post("/customers/forgot-password", data);
};

export const resetPassword = (data) => {
    return api.post("/customers/reset-password", data);
};


// export const getItems = (search = "") => {
//     return api.get(`/e-commerce/items`, { params: { search } });
// };
export const getItems = (params = {}) => {
    return api.get(`/e-commerce/items`, { params });
};


// export const getItemsMaterial = (materialId = "") => {
//     return api.get(`/e-commerce/items`, { params: { materialId } });
// };

export const getOrders = (page) => {
    const token = localStorage.getItem("token");

    return api.get("/orders/customer", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: { page }
    });
};

export const getItemsNew = (newFirst = "true") => {
    return api.get(`/e-commerce/items`, { params: { newFirst } });
};
export const getItemsWithDiscount = (isDiscounted = 1) => {
    return api.get(`/e-commerce/items`, { params: { isDiscounted } });
};
export const verifyEmail = (token) => {
    return api.post("/customers/verify", { token });
};
export const getEvents = () => {
    return api.get("/e-commerce/events");
};
export const getmaterial = () => {
    return api.get("/e-commerce/materials");
};
export const getEvent = (id) => {
    return api.get(`/e-commerce/events/${id}`);
};
export const getProductDetails = (id) => {
    return api.get(`/e-commerce/items/${id}`);
};
export const getGrade = () => {
    return api.get("/e-commerce/grades");
};
export const getItemWishlistStatus = (id) => {
    return api.get(`e-commerce/wish-list/${id}`);
};

// api.js or wherever you define your API functions
export const verifyOrderPayment = (reference) => {
    return api.post(`/orders/customer/${reference}`);
};






export const getWishlist = () => {
    const token = localStorage.getItem("token");
    return api.get("/e-commerce/wish-list", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};


export const AddWishlist = (id) => {
    const token = localStorage.getItem("token");

    return api.post(
        "/e-commerce/wish-list/",
        { itemId: id },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};


export const UpdateCustomer = (data) => {
    return api.put(`/customers`, data, {
        headers: {
            Authorization: `Bearer ${getFromStorage("token")}`,
        },
    });
};



export const UpdateWishlist = (data) => {
    return api.patch(`e-commerce/wish-list`, data, {
        headers: {
            Authorization: `Bearer ${getFromStorage("token")}`,
        },
    });
};

export const CreateOrder = (data) => {
    return api.post("/orders/customer", data);
};


export const getSettings = () => {
    return api.get("/e-commerce/settings");
};


const api = axios.create({
    baseURL:
        process.env.NODE_ENV === "development"
            ? `${process.env.REACT_APP_LOCAL_BASEURL}`
            : `${process.env.REACT_APP_PROD_BASEURL}`,
    headers: {
        "Content-Type": "application/json",
    },
});


api.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${getFromStorage("token")}`;
    return config;
}, null);



api.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (error.response.status === 401) {
            renderErrorMessage(error.response.data.error).then(() => {
                localStorage.clear();
                window.location.reload();
            });
        } else if (error.response.status === 403) {
            renderErrorMessage(error.response.data.error).then(() => {
                window.location.reload();
                localStorage.clear();
            });
        } else {
            renderErrorMessage(error.response.data.error);
            throw new Error(error.response.data.error, {
                cause: error.response.status,
            });
        }
    }
);

